/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */


(function ($) {
  
  $(document).ready(function () {
    
    //  Ajax MailChimp subscription
    $('form.Subscribe__Form').submit(function (e) {
      var $this = $(this);

      $.ajax({
        type: "GET",
        url: "https://fwrdthelabel.us17.list-manage.com/subscribe/post-json?c=?",
        data: $this.serialize(),
        dataType: 'json',
        contentType: "application/json; charset=utf-8",
        error: function (err) { alert("Could not connect to the registration server."); },
        success: function (data) {
          if (data.result != "success") {
            $('p.error-message').html(data.msg);
            $('p.error-message').addClass('error');
          } else {
            $('form.Subscribe__Form').addClass('success');
            $('p.success-message').addClass('success');
            $('.continue-shopping').addClass('success');
            $('p.error-message').removeClass('error');            
          }
        }
      });
      return false;
    });
    
    //  Popup subscription to Mailchimp
    $('#newsletter-popup').submit(function (e) {
      var $this = $(this);

      $.ajax({
        type: "GET",
        url: "https://fwrdthelabel.us17.list-manage.com/subscribe/post-json?c=?",
        data: $this.serialize(),
        dataType: 'json',
        contentType: "application/json; charset=utf-8",
        error: function (err) { alert("Could not connect to the registration server."); },
        success: function (data) {
          if (data.result != "success") {
            $('.Alert--error').html(data.msg);
            $('.Alert--error').show();
            $('.Alert--success').hide();
          } else {
            $('.Alert--success').show();
            $('.Alert--error').hide();
            $('#EMAIL').hide();
            $('.Form__Submit').hide();
          }
        }
      });
      return false;
    });    
    
  });

})(window.jQuery);